import { PastResponse } from '../../../../types';
import { GetResponsesResponse } from '../../../../api';

export const getPastResponses = (
  responsesData: GetResponsesResponse | undefined,
  typeFunc: (responseType: string | undefined) => string | undefined
): PastResponse[] => {
  return responsesData
    ? responsesData.responses
        .filter((resp) => resp.submittedDate)
        .map((resp) => ({
          id: resp.id,
          type: resp.responseType,
          typeDefinition: typeFunc(resp.responseType),
          responseDate: resp.submittedDate,
          response: resp.response ?? '',
          reasonForLateResponse: resp.reasonForLateResponse,
          reasonForLateResponseDetail: resp.reasonForLateResponseDetail,
          document: resp.documents.find((doc) => doc.response),
          supportingDocuments: resp.documents.filter((doc) => !doc.response),
        }))
    : [];
};
